import styled, { css } from "styled-components";

interface StyledNavigationBarProps {
  $isFullScreen: "active" | "";
}

const FolderRoundedStyle = css`
  &::before {
    position: absolute;
    content: "";
    width: 2rem;
    height: 2rem;
    background-color: #070707;
    border-radius: 50%;
    bottom: 0;
    right: 100%;
    z-index: 20;
    pointer-events: none;
  }
  &::after {
    position: absolute;
    content: "";
    width: 2rem;
    height: 2rem;
    background-color: #070707;
    border-radius: 50%;
    bottom: 0;
    left: 100%;
    z-index: 20;
    pointer-events: none;
  }
  & > .menu::before {
    position: absolute;
    content: "";
    width: 1.2rem;
    height: 1.2rem;
    background-color: #32383f;
    bottom: 0;
    right: 100%;
    z-index: 10;
    pointer-events: none;
  }
  & > .menu::after {
    position: absolute;
    content: "";
    width: 1.2rem;
    height: 1.2rem;
    background-color: #32383f;
    bottom: 0;
    left: 100%;
    z-index: 10;
    pointer-events: none;
  }
`;

export const StyledNavigationBar = styled.div<StyledNavigationBarProps>`
  .header-container {
    width: 100%;
    height: ${(props) =>
      props.$isFullScreen === "active" ? "0rem" : "5.6rem"};
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #070707;
    color: #fefefe;
    transition: all 0.2s ease;
    overflow: ${(props) =>
      props.$isFullScreen === "active" ? "hidden" : "visible"};

    & > .navi-wrap {
      display: flex;
      & > .navi {
        display: flex;
        margin-top: 0.8rem;
        align-items: flex-end;
        height: calc(100% - 0.8rem);
        /* background-color: var(--bg-gray-8); */
        & > .tabs {
          width: max-content;
          height: max-content;
          &:first-child > .menu {
            padding: 0.8rem 2rem;
            cursor: pointer;
            svg {
              width: 2.4rem;
              height: 2.4rem;
              padding: 0.4rem;
              path {
                fill: #fefefe;
              }
            }
          }
          & > .menu {
            display: flex;
            justify-content: center;
            align-items: center;
            display: flex;
            align-items: center;
            padding: 1.2rem 1.6rem;
            gap: 0.4rem;
            cursor: pointer;
            text-decoration: none;
            background-color: #070707;
            & > svg {
              position: relative;
              z-index: 100;
            }
            & > p {
              position: relative;
              z-index: 100;
              font: var(--body-large-400);
              color: #fefefe;
            }

            &:last-child {
              border: none;
            }
          }
          &.active {
            position: relative;
            ${FolderRoundedStyle}
            & > .menu {
              border-top-left-radius: 1.2rem;
              border-top-right-radius: 1.2rem;

              background-color: #32383f;
              & > p {
                color: var(--text-gray-normal);
                font: var(--body-large-600);
              }
            }
          }
        }
      }
    }

    & > .right-box {
      display: flex;
      align-items: center;
      & > .project-info-wrap {
        /* padding: 0.8rem 1.2rem 0 1.2rem; */
        padding-right: 1.2rem;
        display: flex;
        flex-flow: column nowrap;
        gap: 0.6rem;
        align-items: flex-end;
        .title {
          font: var(--label-small-600);
          color: var(--text-gray-normal);
        }
        .info {
          display: flex;
          gap: 0.4rem;
          & > div {
            background-color: var(--bg-gray-3);
            padding: 0 0.4rem;
            border-radius: 0.4rem;
            height: 1.6rem;
            display: flex;
            align-items: center;
            & > p {
              font: var(--label-small-400);
              color: var(--text-gray-strong);
              & > span {
                font: var(--label-small-600);
              }
            }
          }
        }
      }
      & > .super-user-flag {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;

        padding: 4px 8px;
        border-radius: 4px;
        background: var(--secondary-orange-4, #ff7a21);

        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 166.667% */
        z-index: 30;

        & > .super-user-icon {
          width: 16px;
        }
      }
      & > .profile-wrap {
        /* padding: 0 1rem; */
        padding: 0.8rem 1.2rem;

        & > .profile.super-user {
          border: 2px var(--secondary-orange-4, #ff7a21) solid;
        }

        & > .profile {
          position: relative;
          width: 3.2rem;
          height: 3.2rem;
          background: var(--bg-gray-2);
          color: var(--text-gray-9);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font: var(--button-medium);
          cursor: pointer;
          /* 양희철: 맥 safari에선 user-select: none; 이 안먹혀서 수정 */
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-use-select: none;
          user-select: none;

          .menu-list {
            display: flex;
            flex-flow: column nowrap;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
            position: absolute;
            z-index: 100000;
            top: calc(100% + 1rem);
            right: -0.4rem;
            padding: 0;
            border-radius: 0.4rem;

            .rectangle {
              position: absolute;
              top: -0.4rem;
              right: 1.6rem;
              width: 1rem;
              height: 1rem;
              background-color: var(--bg-gray-2);
              border-radius: 0.2rem;
              transform: rotate(45deg);
            }

            .list {
              width: 13.6rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0.8rem 1.2rem;
              background: var(--bg-gray-2);
              & > p {
                font: var(--button-small);
                color: var(--text-gray-7);
              }
              &:hover {
                background-color: var(--bg-gray-0);
              }
              &:first-child {
                border-top-left-radius: 0.4rem;
                border-top-right-radius: 0.4rem;
                &:hover ~ .rectangle {
                  background-color: var(--bg-gray-0);
                }
              }
              &:last-child {
                border-bottom-left-radius: 0.4rem;
                border-bottom-right-radius: 0.4rem;
              }

              &.theme {
                width: 14.4rem;
                padding: 0.4rem 0.4rem 0.4rem 1.2rem;
                .theme-btn {
                  position: relative;
                  display: flex;
                  gap: 0.2rem;
                  padding: 0.2rem;
                  border-radius: 9.9rem;
                  transition: all 0.2s ease;

                  & > .icon {
                    position: relative;
                    z-index: 10;
                    display: flex;
                    padding: 0.2rem 0.6rem;
                    & > svg {
                      width: 1.6rem;
                      height: 1.6rem;
                    }
                  }

                  .background {
                    position: absolute;
                    z-index: 9;
                    width: 1.2rem;
                    height: 1.2rem;
                    padding: 0.4rem 0.8rem;
                    border-radius: 9.9rem;
                    transition: all 0.2s ease;
                  }

                  &.dark {
                    background-color: var(--accent-navy);
                    .icon {
                      svg path {
                        stroke: var(--text-gray-normal);
                      }
                      &.active svg path {
                        stroke: var(--accent-blue);
                      }
                    }
                    .background {
                      background-color: var(--normal);
                    }
                    &:hover {
                      .icon.active svg path {
                        stroke: var(--normal);
                      }
                      .background {
                        background-color: var(--accent-blue);
                      }
                    }
                  }

                  &.light {
                    background-color: var(--accent-apricot);
                    .icon {
                      svg path {
                        stroke: var(--text-gray-normal);
                      }
                      &.active svg path {
                        stroke: var(--accent-mandarin);
                      }
                    }
                    .background {
                      background-color: var(--bg-gray-normal);
                    }
                    &:hover {
                      .icon.active svg path {
                        stroke: var(--text-gray-normal);
                      }
                      .background {
                        background-color: var(--accent-mandarin);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
